module.exports = __webpack_public_path__ + "img/01.32d70213.jpg";